import { Button } from "components";
import styles from "./Menu.module.css";
import Navigation from "./Navigation";

interface MenuProps {
  onSignOut(): void;
}

const Menu: React.FC<MenuProps> = ({ onSignOut }) => (
  <div className={styles.container}>
    <Navigation />
    <Button
      onClick={onSignOut}
      placeContent="flex-start"
      iconStart="logout"
      filled
      style={{ backgroundColor: "#33C6F4"}}
    >
      Sign out
    </Button>
  </div>
);

export default Menu;
